<template>
  <div class="coproducer-product-links-view">
    <action-dispatcher
      action="user/getMyCoproducer"
      :parameters="{ limit: 100 }"
    >
      <template v-if="product">
        <page-header>
          <template #custom-header>
            <product-dropdown :product="product" />
          </template>
        </page-header>
        <page-container>
          <bp-header
            class="mb-7"
            title="Links de divulgação"
            subtitle="Veja os links gerados para divulgação do seu produto."
          />
          <links
            :product="{
              ...product,
              url: `https://pay.${$config.domain}/${product.code}`
            }"
          />
        </page-container>
      </template>
    </action-dispatcher>
  </div>
</template>

<script>
import ProductDropdown from "@/components/product/ProductDropdown";
import Links from "@/components/product/coproducer/Links.vue";
import { mapState } from "vuex";
export default {
  components: { ProductDropdown, Links },
  computed: {
    ...mapState("user", ["myCoproducers"]),
    product() {
      return this.myCoproducers.find(
        coproduction =>
          coproduction?.product?.id === parseInt(this.$route.params.id)
      )?.product;
    }
  }
};
</script>
